window.showSegmentSelect = function(element) {
	$(element).closest(".js-segment-selection").find("[data-segment]").addClass('is-hidden');
	$(element).closest(".js-segment-selection").find("[data-segment] > select").prop('disabled', true);

	$(element).closest(".js-segment-selection").find(`[data-segment="${$(element).val()}"]`).removeClass('is-hidden');
	$(element).closest(".js-segment-selection").find(`[data-segment="${$(element).val()}"] > select`).prop('disabled', false);
}

window.toggleDisabledForTableFields = function(element){
	if($(element).is(':checked')){
		$('.js-report-table-fields').prop('disabled', false);
	} else {
		$('.js-report-table-fields').prop('disabled', true);
	}
}